import * as React from "react";
const SvgIcMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 3, y: 6, width: 8, height: 2, fill: "white" }));
export default SvgIcMinus;
